<template>
  <section id="top" class="position-relative text-white t1-hero-bg t1-section-px" :style="{ backgroundImage: `url(${image})` }">
    <div class="t1-hero-overlay"></div>
    <div class="container-lg position-relative py-5 t1-hero-inner">
      <div class="row">
        <div class="col-lg-7" data-aos="fade-up">
          <div class="eyebrow texttertiary mb-2">Licensed &bull; Bonded &bull; Insured</div>
          <h1 class="display-4 font-weight-bold mb-3">
            Dependable <strong class="texttertiary">{{ trade }}</strong> on site when you need them.
          </h1>
          <p class="text-white-50 mb-4">
            Whether it's a local run or across the region
          </p>

          <div class="mb-4">
            <a href="#quote" class="btn backgroundtertiary text-white notextdeco mr-2 mb-2">Contact us now</a>
            <a href="#services" class="btn btn-outline-light mb-2">See Our Services</a>
          </div>


        </div>
      </div>

      <div class="backgroundsecondary text-white rounded emd-shadow-md p-3 d-none d-sm-flex align-items-center t1-hero-badge">
        <i class="bi bi-shield-check texttertiary mr-2" style="font-size: 1.5rem;"></i>
        <div>
          <strong class="d-block">{{ years }}+ yrs</strong>
          serving the region
        </div>
      </div>
      
    </div>
    
  </section>
</template>

<script>
export default {
  name: 'Theme1HomePagePart1Hero',
  props: {
    years: { type: [Number, String] },
    trade: { type: String, default: 'Freight' },
    image: {
      type: String,
      default: 'https://m9.emerld.dev/media/truck-2018.png',
    },
  },
};
</script>
